import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';


@Component({
  selector: 'app-student-fee-detail',
  templateUrl: './student-fee-detail.component.html',
  styleUrls: ['./student-fee-detail.component.css']
})
export class StudentFeeDetailComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }
  StudentList:any;
  GetStudentDetails() {
    this.studentPortalService.GetStudentDetails_StudentPortal().subscribe((data: any) => {
            this.globalHelper.CheckActionStatus(data);
     if (data.webResponse.Status) {
                this.StudentList = data.StudentList;
                this.SearchModel.StudentID = data.StudentList[0].StudentID;
                this.GetPaymentReceiptPrimary();
                this.GetID(this.StudentList[0]);
            }
        });
    
};

PrintFeeReceipt(ReceiptNo, PrintType, CopyType, Cancel) { 
    var Template = this.globalHelper.GetLoginToken().FeeTemplate;
    if (Cancel == 'Yes') {
     CopyType = 'C';
    }
     var url = Template + "?PrintTypes=FeeReceipt&ReceiptNo=" + ReceiptNo + "&PrintType=" + PrintType + "&CopyType=" + CopyType;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
};

GetID  (item) {
  
  this.FeeReceiptModel.ClassID = item.ClassID;  
  this.FeeReceiptModel.OpeningAmount = 0;
  this.FeeComponentList =[];
  this.ComponentList = [];
  this.FeeReceiptModel = item; 
  this.GetFeeInstallmentComponent();  
  this.FeeReceiptModel.PaymentMode = "CASH";
}
FeeReceiptModel = {

  ClassID: "0",
  StudentID: "0",
  FirstName: '',
  MiddleName: '',
  LastName: '',
  ClassName: '',
  StreamName: '',
  StudentName: '',
  PaymentMode: '',
  PaidAmount: 0,
  FeeAmount: 0,
  Fine: 0,
  OpeningAmount: 0,
  WaiverAmount: 0,
  BankCharges: 0,
  BankAccountID: 0,
}
SearchModel = {
  StudentID: 0,
  SectionID: 0,
  CancelStatus: 'N',
  ClassID: 0,
  StudentNo: '',
  FromDate: '',
  PaymentMode: '',
  ToDate: '',
  CreatedBy: 0
}
PaymentReceiptList:any;
GetPaymentReceiptPrimary  () {
  
  this.studentPortalService.GetPaymentReceipt(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.PaymentReceiptList = response.PaymentReceiptList;
      var TotalPaidAmounts = 0;
      var TotalFineAmounts = 0;
      for (var i = 0; i < this.PaymentReceiptList.length; i++) {
          TotalPaidAmounts = TotalPaidAmounts + this.PaymentReceiptList[i].PaidAmount;
          TotalFineAmounts = TotalFineAmounts + this.PaymentReceiptList[i].Fine;
      }
   
    
  });
}
FeeComponentList:any;
ComponentList:any;
GetFeeInstallmentComponent  () {
  
  this.studentPortalService.GetFeeInstallmentComponent(this.FeeReceiptModel.ClassID, this.FeeReceiptModel.StudentID).subscribe((response: any) => {
      if (response.webResponse.Status) {
          this.FeeComponentList = response.FeeComponentList;
          this.ComponentList = response.ComponentList;

          var TotalPaidAmount = 0;
          var TotalPayableAmount = 0;
          for (var i = 0; i < this.FeeComponentList.length; i++) {
              TotalPayableAmount = TotalPayableAmount + (this.FeeComponentList[i].TotalAmount - this.FeeComponentList[i].DiscountAmount);
              TotalPaidAmount = TotalPaidAmount + this.FeeComponentList[i].PaidAmount;
          }
        
      }
  });
};

  ngOnInit() {
    this.GetStudentDetails();
  }

}
